import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";

function ImproveVteRiskAssessmentFooter() {
  return (
    <ByzMuiTypography
      isTitle={false}
      sx={{ textAlign: "left", whiteSpace: "pre-line" }}
    >
      {`0-1 puan VTE riski düşük; 2-3 VTE riski orta; >4 puan VTE riski yüksek.

Trombofili: Konjenital veya edinsel trombofili.

Kanser: Son 5 yıl içinde geçirilmiş remisyonda kanser (melanoma dışı cilt kanserleri hariç)

Alt ekstremite paralizisi veya parestezisi: Yerçekimine kısmen direnebilen ama 5 saniye içinde yatağa düşen bacak.

İmmobilizasyon: Tam tanımı, yatak yada sandalyede >7 gün tam hareketsizlik;
Modifiye tanımı ise yatak yada sandalyede >1 gün tam hareketsizlik.

VTE: Venöz tromboembolizm, YBÜ: Yoğun Bakım Ünitesi`}
    </ByzMuiTypography>
  );
}

export default ImproveVteRiskAssessmentFooter;


